import React from 'react';
import { Box, RoundDoneIcon, Text } from '@common-fe/common-fe';

import AppButton from '@/components/controls/AppButton';

interface ResetPasswordSuccessProps {
  onGoToLogin: () => void;
}

const ResetPasswordSuccess: React.FC<ResetPasswordSuccessProps> = ({ onGoToLogin }) => {
  return (
    <Box
      dir="column"
      align="center"
      data-testid="reset-password_success-screen"
    >
      <RoundDoneIcon size="48px" data-testid="reset-password_success-icon" />

      <Text
        size="2xl"
        weight={700}
        textAlign="center"
        margin={{ top: 'spacing8' }}
        data-testid="reset-password_success-title"
      >
        Password Updated
      </Text>

      <Text
        textAlign="center"
        size="large"
        margin={{ top: 'spacing8' }}
        data-testid="reset-password_success-subtitle"
      >
        You can now sign in with your new password.
      </Text>

      <Box margin={{ top: 'spacing16' }} width="100%">
        <AppButton
          testId="reset-password_go-to-login-btn"
          onClick={onGoToLogin}
          width="100%"
          size="L"
        >
          Sign In
        </AppButton>
      </Box>
    </Box>
  );
};

export default ResetPasswordSuccess;
